import { mapState } from "vuex";
import menus from "./menus";

import "./styles.scss";

export default {
  name: "DrawerNavigation",
  computed: {
    ...mapState("User", ["userAuth"])
  },
  methods: {
    async logout() {
      this.$router.push("/login");
      localStorage.clear();
    }
  },
  render(createElement) {
    return createElement("ul", [
      menus(this.userAuth).map(menu =>
        createElement(
          "router-link",
          {
            attrs: {
              tag: "li",
              to: {
                name: menu.route,
                params: menu.params || {}
              }
            },
            class: {
              "item-navigate": true,
              ...(menu.class || {})
            }
          },
          [
            createElement(
              "i",
              {
                class: {
                  "material-icons": true,
                  "icon-navigate": true
                }
              },
              menu.icon
            ),
            createElement("p", menu.text)
          ]
        )
      ),
      createElement(
        "li",
        {
          on: {
            click: this.logout
          },
          class: {
            "item-navigate": true,
            "hide-on-large-only": true
          }
        },
        [
          createElement(
            "i",
            {
              class: {
                "material-icons": true,
                "icon-navigate": true
              }
            },
            "power_settings_new"
          ),
          createElement("p", "Sair")
        ]
      )
    ]);
  }
};
